var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-message"},[_c('div',[(_vm.error)?[_c('c-icon',{attrs:{"icon":"exclamation-triangle"}})]:[_c('c-spinner',{attrs:{"size":"lg"}})],_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }